import React, { useLayoutEffect } from 'react';

const normalizeTitle = (children) => {
  if (typeof children !== 'string' && typeof children !== 'number') {
    return null;
  }

  const title = String(children).trim();
  return title && title !== '--' ? title : null;
};

const Title = ({ children }) => {
  useLayoutEffect(() => {
    const title = normalizeTitle(children);

    if (!title) {
      return undefined;
    }

    const previousTitle = document.title;
    document.title = title;

    return () => {
      if (document.title === title) {
        document.title = previousTitle;
      }
    };
  }, [children]);

  return null;
};

export { Title };
